import { connect } from 'react-redux';
import withRedux from '../../../withRedux';
import ConnectApplication from './ConnectApplication';
import {
  connectApplication,
  resetConnectApplicationError,
} from '../../../store/ciam/ciam.actions';
import {
  getApplicationConnectFailed,
  getApplicationAbsentParty,
} from '../../../store/ciam/ciam.selectors';
import { executeGrecaptcha } from '~/store/captchaMiddleware';

export const QUERY_STRING_APP_ID = 'appId';

const mapStateToProps = (state) => ({
  hasConnectFailed: getApplicationConnectFailed(state),
  hasAbsentParty: getApplicationAbsentParty(state),
});

const mapDispatchToProps = (dispatch) => ({
  connectApplication: (id, isMobileApp) => {
    const search = new URLSearchParams(location.search);
    const oldAppId = search.get(QUERY_STRING_APP_ID);
    executeGrecaptcha('connect_application').then((token) =>
      dispatch(connectApplication(id, oldAppId, isMobileApp, token))
    );
  },
  closeErrorModal: () => {
    dispatch(resetConnectApplicationError());
  },
});

export default withRedux(
  connect(mapStateToProps, mapDispatchToProps)(ConnectApplication)
);
